import React from 'react'
import cn from 'classnames'
import { InterfaceCheckmarkSmall } from '@dsk/core/icons'
import { Icon, InterfaceWarningIcon, InterfaceOkIcon } from '@grammarly/design-system'

import Plagiarism from '../helpers/plagiarism-helper'
import { CounterWithBorder, SizeMultiplier } from '../counter'

import style from './icons.module.scss'

interface IconProps {
  className?: string
}

export const IconNoIssues = () => (
  <svg width="87" height="87" viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="44" cy="44" r="36" fill="var(--green-20)" />
    <circle cx="44" cy="44" r="30" fill="var(--green-40)" />
    <circle cx="44" cy="44" r="24" fill="var(--green-60)" />
    <path d="M1.5 6.5L4 9l7.5-7.5" stroke="var(--color-text-base-inverse)" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

export const IconNoErrors: React.FC<IconProps> = ({ className }) => (
  <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>No Issues Found</title>
    <circle cx="16" cy="16" r="10" fill="#018374" />
    <path d="M11.5 17.5L14 20L21.5 12.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
  </svg>
)

interface ReportSummaryCircleProps {
  totalErrors: number
  plagiarism: Plagiarism
  color?: 'goldOnYellow' | 'whiteOnRed'
  multiplier?: SizeMultiplier
}

export const ReportSummaryCircle: React.FC<ReportSummaryCircleProps> = ({
  totalErrors,
  plagiarism,
  color,
  multiplier = 6,
}) => (
  <>
    {plagiarism.isPresent ? (
      <CounterWithBorder multiplier={multiplier} alertCount="!" color={color} />
    ) : totalErrors ? (
      <CounterWithBorder multiplier={multiplier} alertCount={totalErrors} color={color} />
    ) : (
      <div className={style.reportSummaryContainer}>
        <IconNoIssues />
        <span className={style.errorCount}>
          <InterfaceCheckmarkSmall className={style.iconCheckmark} />
        </span>
      </div>
    )}
  </>
)

interface ReportSummaryIconProps {
  hasErrors: boolean
  plagiarism: Plagiarism
  location: 'side' | 'inline'
}

export const ReportSummaryIconPrecise: React.FC<ReportSummaryIconProps> = ({ hasErrors, plagiarism, location }) => {
  return (
    <span className={cn(location === 'side' && style.iconSide, location === 'inline' && style.iconInline)}>
      {!plagiarism.isPresent && !hasErrors ? (
        <Icon icon={InterfaceOkIcon} accessibilityLabel="" className={style.reportSummaryIcon} />
      ) : (
        <Icon icon={InterfaceWarningIcon} accessibilityLabel="" className={style.reportSummaryIcon} />
      )}
    </span>
  )
}
